<template>
  <div class="position-absolute v-header z-3">
    <div class="col-12">
      <div class="row">
        <div
          class="col-12 ps-4 pe-4 d-flex align-items-center justify-content-center v-theme-header"
        >
          <button
            @click="navigateBack"
            :class="{
              'btn-close-asset': this.heading != '360-tour',
              'btn-close-asset-rev': this.heading === '360-tour',
            }"
          ></button>
          <!-- <button @click="$router.go(-1)" class="btn-close-asset" v-if="this.viewType != 'floorplans'"></button>
          <button @click="$router.go(-1)" class="btn-close-asset-rev" v-if="this.viewType == 'floorplans'"></button> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DetailTopNav",
  props: ["heading", "subheading"],
  data() {
    return {
      componentName: "AssetView",
    };
  },
  methods: {
    navigateBack() {
      // This is the core logic for navigating back
      this.$router.back();
      // OR this.$router.go(-1);
    },
  },
};
</script>
